"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMixPanelAttributes = void 0;
const getMixPanelAttributes = (attributes) => {
    // attributes tracked by mixpanel sdk by default to be removed
    const deleteAttributes = ['current_url', 'debug'];
    deleteAttributes.forEach(attribute => {
        delete attributes[attribute];
    });
    return {
        ...attributes,
    };
};
exports.getMixPanelAttributes = getMixPanelAttributes;
//# sourceMappingURL=mixpanel.js.map